import { createFileRoute } from "@tanstack/react-router";
import type React from "react";
import { useTranslation } from "react-i18next";

import BasicCompanyData from "@/features/settings/basic-settings/basic-company-data";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/eckdaten",
)({
  component: BasicData,
});

function BasicData() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex flex-col mb-5 w-full">
        <div className="font-bold text-xl mb-5">{t("basic_data.title")}</div>
        <BasicCompanyData />
      </div>
    </div>
  );
}
